import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.config.productionTip = false;
// 请求封装
import http from './api/api.js'
Vue.prototype.$http = http
//element ui 提示唯一显示封装
import gtMessage from './message'
Vue.prototype.$message = gtMessage
// 成功调用方式：this.$message.success(options);
// 失败调用方式：this.$message.error(options);
// 警告调用方式：this.$message.warning(options);
// 提示调用方式：this.$message.info(options);

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
